// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckoutToggleController from "./checkout_toggle_controller"
application.register("checkout-toggle", CheckoutToggleController)
import ConsentExpiryController from "./consent_expiry_controller"
application.register("consent-expiry", ConsentExpiryController)
import ConsentReportsController from "./consent_reports_controller"
application.register("consent-reports", ConsentReportsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ScrollspyController from "./scrollspy_controller"
application.register("scrollspy", ScrollspyController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import HealthScoreController from "./health_score_controller"
application.register("health-score", HealthScoreController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhoneOtpController from "./phone_otp_controller"
application.register("phone-otp", PhoneOtpController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)
